<label [id]="fieldId+'-addon'">{{ label }}</label>
<div class="input-group mb-3">
    <div class="custom-file">
      <input type="file" class="custom-file-input" [id]="fieldId" [multiple]="multiple" [accept]="accept">
      <label [ngClass]="{'ng-invalid': invalid}" class="custom-file-label" [for]="fieldId">
        {{ displayText }}
      </label>
    </div>
</div>
